import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { API, Card, cents, when } from './dsfApi';

export const DsfSettingsCard = ({ settings, onSaved }) => {
    const [maxWin, setMaxWin] = useState('');
    const [levels, setLevels] = useState([]);
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        if (!settings) return;
        setMaxWin((settings.max_win_cents / 100).toFixed(2));
        setLevels(settings.bet_levels_cents);
    }, [settings]);
    if (!settings) return null;
    const toggle = (lv) => setLevels((l) => (l.includes(lv) ? l.filter((x) => x !== lv) : [...l, lv].sort((a, b) => a - b)));
    const save = async () => {
        const c = Math.round(Number(maxWin) * 100);
        if (!Number.isFinite(c) || c < 100 || c > settings.max_win_ceiling_cents) { toast.error(`Max win must be $1.00 – ${cents(settings.max_win_ceiling_cents)}`); return; }
        if (!levels.length) { toast.error('Keep at least one bet size on'); return; }
        setSaving(true);
        try {
            const { data } = await axios.put(`${API}/admin/dsf/settings`, { max_win_cents: c, bet_levels_cents: levels }, { withCredentials: true });
            onSaved(data);
            toast.success('Saved — live in the game within a few seconds');
        } catch (e) {
            toast.error(e.response?.data?.detail || 'Save failed');
        } finally { setSaving(false); }
    };
    return (
        <Card title="Limits" testid="dsf-settings-card">
            <label className="mb-1 block text-xs text-[#A0AAB2]">Biggest single prize (max {cents(settings.max_win_ceiling_cents)})</label>
            <Input value={maxWin} onChange={(e) => setMaxWin(e.target.value)} inputMode="decimal" className="mb-4 max-w-[180px] bg-black/40 text-white" data-testid="dsf-max-win-input" />
            <p className="mb-2 text-xs text-[#A0AAB2]">Bet sizes players can pick</p>
            <div className="mb-4 flex flex-wrap gap-2">
                {settings.all_bet_levels_cents.map((lv) => (
                    <button key={lv} type="button" onClick={() => toggle(lv)} data-testid={`dsf-bet-level-${lv}`}
                        className={`rounded-full border px-3 py-1 text-sm font-bold transition-colors ${levels.includes(lv) ? 'border-[#39FF14] bg-[#39FF14]/15 text-[#39FF14]' : 'border-white/15 text-white/40'}`}>
                        {cents(lv)}
                    </button>
                ))}
            </div>
            <div className="flex flex-wrap items-center gap-3">
                <Button onClick={save} disabled={saving} className="bg-[#39FF14] text-black hover:bg-[#39FF14]/90" data-testid="dsf-settings-save">{saving ? 'Saving…' : 'Save limits'}</Button>
                <span className="text-xs text-white/40">Last change: {when(settings.updated_at)} {settings.updated_by ? `by ${settings.updated_by}` : ''}</span>
            </div>
        </Card>
    );
};
